export default "__VITE_ASSET__Drta74Cp__"